import React from 'react';
import { MenuDivider as BPMenuDivider } from '@blueprintjs/core';
export function ToolbarMenuLabel(props) {
    const { label } = props;
    return React.createElement(BPMenuDivider, { title: label.label });
}
export default ToolbarMenuLabel;
